import { from, Observable } from "rxjs";
import { Signer } from "@aws-amplify/core";
import { ajax, AjaxResponse, } from 'rxjs/ajax'
import { getAsyncCurrentUser } from './user';
import { EndpointsName } from '.';
import awsmobile, { endpoints } from "./aws-exports";

enum REST {
    GET = 'GET',
    PUT = 'PUT',
    DELETE = 'DELETE'
}

const buidlFullURL = (url: string, path: string, factory: string, method: string) => {

    if(method === REST.PUT) {
        return `${endpoints[url]}/${factory}${path}`
    }

    if(url === EndpointsName.GLOBAL){
        return `${endpoints[url]}${path}/${factory}`;
    }

    if(url === EndpointsName.MAINTENANCE) {
        return `${endpoints[url]}${path}${factory.toLowerCase()}`;
    }

    return `${endpoints[url]}/${factory}${path}`
}

const createSignedRequest = async (method: string, url: string, path: string, data: string = "") => {
    const { factory, username, credentials } = await getAsyncCurrentUser();
    const request = {
        method: method,
        url: buidlFullURL(url, path, factory, method),
        headers: { 'Content-Type': 'application/json; charset=UTF-8', User: username },
        data: data
    }
    const { accessKeyId, secretAccessKey, sessionToken } = credentials

    const accessInfo = {
        access_key: accessKeyId,
        secret_key: secretAccessKey,
        session_token: sessionToken,
    };

    const serviceInfo = {
        service: "execute-api",
        region: awsmobile.Auth.region,
    };

    const signedRequest = Signer.sign(request, accessInfo, serviceInfo);
    delete signedRequest.headers["host"]; //Remove host header
    return signedRequest;
};

const buildGET = async (url: string, path: string, skipSignRequest = false) => {
    const request = await createSignedRequest(REST.GET, url, path)
    return ajax.getJSON(request.url, skipSignRequest ? null : request.headers).toPromise()
}

const buildDelete = async (url: string, path: string, skipSignRequest = false) => {
    const request = await createSignedRequest(REST.DELETE, url, path)
    return ajax.delete(request.url, skipSignRequest ? null : request.headers).toPromise()
}

const buildPut = async (url: string, path: string, value: any) => {
    const request = await createSignedRequest(REST.PUT, url, path, value ? JSON.stringify(value) : '')
    return ajax.put(request.url, request.data, request.headers).toPromise()
}

export const get = <T>(url: string, path: string, skipSignRequest = false) => from(buildGET(url, path, skipSignRequest)) as Observable<T>;
export const put = (url: string, path: string, value: any) => from(buildPut(url, path, value)) as Observable<AjaxResponse>;
export const deleteMethod = (url: string, path: string) => from(buildDelete(url, path)) as Observable<AjaxResponse>;
